module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "log-w3"
  }, [_c('div', {
    staticClass: "w3layouts-main",
    staticStyle: {
      "background": "rgba(0,0,0,0.6)"
    }
  }, [_c('h2', [_vm._v("Cityneeds Admin")]), _vm._v(" "), (_vm.mod_message != 'nill') ? _c('p', {
    staticClass: "col-md-12"
  }, [_c('u', [_vm._v(_vm._s(_vm.mod_message))])]) : _vm._e(), _vm._v(" "), (_vm.setActionPanel) ? _c('div', [(_vm.setResetPasswordPanel) ? _c('form', [_c('h4', [_vm._v("Reset Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.new_password),
      expression: "admin.new_password"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "password",
      "placeholder": "Enter new Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.confirm_password),
      expression: "admin.confirm_password"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.confirm_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset")]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.setForgetPasswordPanel) ? _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.email),
      expression: "admin.email"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "email",
      "placeholder": "Enter E-MAIL",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("Continue")])]) : _vm._e()]) : _c('div', [_c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.email),
      expression: "admin.email"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "email",
      "placeholder": "E-mail",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.admin.password),
      expression: "admin.password"
    }],
    staticClass: "ggg",
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.admin.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.admin.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('h6', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set_forgot', '')
      }
    }
  }, [_vm._v("Forgot Password?")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("processing...please wait")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02941b72"}!./src/components/Login/template.html
// module id = 150
// module chunks = 0